import React,{useEffect,useRef} from "react";
import css from "./SideBarNavigator.module.css";
import {isTouchDevice,capitalize} from "vritra";
import {SideBarNavigator as Component} from "react-vritra";
import {useLocation} from "react-router-dom";


export default function SideBarNavigator(props){
    const {tintColor,onNavigate}=props,domref=useRef();
    const {pathname,hash}=useLocation();
    useEffect(()=>{
        const element=domref.current;
        if(element){
            const entry=element.getCurrentEntry();
            entry&&setDocumentTitle(entry);
        }
    },[]);
    return <Component
        {...props} domref={domref}
        className={css.sidebarnavigator+" "+(props.className||"")}
        sidebarClassName={css.sidebar+" "+(props.sidebarClassName||"")}
        containerClassName={css.container+" "+(props.containerClassName||"")}
        folderColor={textColor}
        endpointColor={textColor}
        tintColor={tintColor||minorColor}
        sidebarShown={!isTouchDevice()}
        entryId={hash.substring(1).toLowerCase()} 
        fallbackEntryId={props.initialId}
        sideBarScrollTheme={hasLightTheme?"dark":"light"}
        onNavigate={(current,previous)=>{
            setDocumentTitle(current);
            location.replace(`#${pathname}#${current.id}`);
            if(isTouchDevice()){
                domref.current.toggleSideBar(false);
            }
            onNavigate&&onNavigate(current.id,previous?.id);
        }}
    />
}

const setDocumentTitle=(entry)=>{
    document.title=capitalize(entry.name||entry.id)+" \u2022 Vritra";
}
